module.exports = __webpack_public_path__ + "static/widget-img-10-fa1cd95904275bf3d929cbc7e3b5b88e.png";